var _rect, _g, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#2196F3",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,100) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -60,
    width: 120,
    height: 120,
    fill: "#42A5F5",
    rx: 5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 45,
    fill: "none",
    stroke: "white",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 112,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "white"
  }, "acm")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcmLogo);
export default __webpack_public_path__ + "static/media/acm-logo.c1f28460b91d6f3d5c737ffe1434109b.svg";
export { ForwardRef as ReactComponent };